
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 53 60.74"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Ebene_2","data-name":"Ebene 2"}},[_c('text',{attrs:{"transform":"translate(20.29 46.23)","font-size":"54.03","stroke-miterlimit":"10","stroke-width":"2","font-family":"MyriadPro-Regular,Myriad Pro","id":"Ebene_1-2","data-name":"Ebene 1"}},[_v('!')])])])
          )
        }
      }
    